import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ContactSupportBtn = () => {
  const { t } = useTranslation('common');
  return (
    <Button
      component="a"
      variant="text"
      href="mailto:info@holoray.com"
      aria-label={t('DASHBOARD_OTHER_LINKS.CONTACT_SUPPORT')}
      rel="noopener noreferrer"
    >
      <Typography sx={{ textDecoration: 'underline', color: 'common.white' }}>
        {t('DASHBOARD_OTHER_LINKS.CONTACT_SUPPORT')}
      </Typography>
    </Button>
  );
};

export default ContactSupportBtn;
